import React, { useEffect } from 'react';

import { formatMoney, toMoney } from '@betterment/core';
import { track } from '@betterment/js-runtime';
import { Box } from '@betterment/samba-react';
import { Button, CenteredWorkflowLayout, FormikField, Heading, InputGroup } from '@betterment/style-closet-react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import { DirectDepositStepProps } from './data';
import { useTitleDispatch } from './utils';

import { toCentsFromDollarString } from '../../../Shared/models/money';

interface FormProps {
  value: string;
}

const DollarFormSchema = Yup.object().shape<Partial<{}>>({
  value: Yup.string()
    .required('Amount cannot be blank')
    .test('value', 'Amount must be greater than $0', (v: string | undefined) => !!v && toCentsFromDollarString(v) > 0),
});

export const PayCheckAmountField: React.FC<React.PropsWithChildren<DirectDepositStepProps>> = ({
  flowState,
  goToNextStep,
}) => {
  const processForm = (formValues: FormProps) => {
    track('ElementClicked', { name: 'SaveAmountofPaycheck', module: 'SetUpDirectDeposit' });
    const value = toCentsFromDollarString(formValues.value);
    goToNextStep({ payCheckAmount: { type: 'cents', value } });
  };

  const setTitle = useTitleDispatch();
  const { payCheckAmount } = flowState.values;
  let value = '';
  if (payCheckAmount?.type === 'cents') {
    value = formatMoney(toMoney(payCheckAmount.value));
  }

  useEffect(() => setTitle('Direct deposit form'), [setTitle]);
  return (
    <>
      <Heading variant="primary">How much of each paycheck do you want to deposit?</Heading>
      <Box
        css={{
          marginTop: 'space.300',
        }}
      >
        <Formik
          onSubmit={processForm}
          validationSchema={DollarFormSchema}
          initialValues={{ value }}
          validateOnBlur={false}
          enableReinitialize={true}
        >
          {({ isSubmitting }) => (
            <Form>
              <InputGroup>
                <FormikField name="value" id="value" label="Dollar amount" placeholder="" as="money" />
              </InputGroup>
              <CenteredWorkflowLayout.Actions>
                <Button type="submit" disabled={isSubmitting}>
                  Save
                </Button>
              </CenteredWorkflowLayout.Actions>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};
